// extracted by mini-css-extract-plugin
export default {"container":"TeamVisibility_container__VP9wF","list":"TeamVisibility_list__joqVq"};